import React from 'react';
import OrganizationDashboard from 'screens/organizations/components/OrganizationDashboard';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationDashboardScreen = () => <OrganizationDashboard />;

export default OrganizationDashboardScreen;

OrganizationDashboardScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper>{page}</MemberOnlyOrganizationWrapper>
);
